export const USER_ACTION_PERMISSIONS = Object.freeze({
    VIEW_EDUCATION_PAGE: 'Assign content',
    VIEW_REPORTS_PAGE: 'Reports',
    CREATE_EDIT_USERS_GROUPS: 'Create and edit users (including groups)',
    CREATE_EDIT_CUSTOM_EDUCATION: 'Create and edit custom education',
    MANAGE_DEPARTMENT_AND_UNITS: 'Manage departments and units',
    CHANGE_USER_ROLE: "Change a user's role",
    MANAGE_SCOPE: 'Manage scope',
    CHECKLIST_GRADING: 'Grade Skills Checklists',
});

export const hasPermission = (userPermissionList: string[], action: string) =>
    userPermissionList.includes(action);
